import routeNames from './routeNames';
import store from '@/store';
import { prependNamespace } from '@/store/modules/researcherSignup';
import * as types from '@/store/types';
import * as Segment from '@/utils/segment';
import Organization from '@/views/Organization';
import Personal from '@/views/Personal';
import Signup from '@/views/Signup';

const signupFormComplete =
  store.getters[prependNamespace(types.SIGNUP_COMPLETE)];
const orgFormComplete = store.getters[prependNamespace(types.ORG_COMPLETE)];
const personalFormComplete =
  store.getters[prependNamespace(types.PERSONAL_FORM_COMPLETE)];

const validateAndSendEvent = (validator, segmentEvent) => (to, from, next) => {
  if (!validator()) {
    return next({ name: routeNames.home });
  }
  if (segmentEvent) {
    Segment.trackResearcher(segmentEvent);
  }

  return next();
};

export const protectedRoutes = [routeNames.organization, routeNames.personal];

export default [
  {
    path: '/',
    name: routeNames.home,
    component: Signup,
    props: (r) => ({ as: r.query.signupAs }),
    beforeEnter: (to, from, next) => {
      if (!signupFormComplete()) {
        return next();
      }
      if (personalFormComplete()) {
        return next({ name: routeNames.complete });
      }
      if (orgFormComplete()) {
        return next({ name: routeNames.team });
      }

      return next({ name: routeNames.organization });
    },
  },
  {
    path: '/organization',
    name: routeNames.organization,
    component: Organization,
    beforeEnter: validateAndSendEvent(signupFormComplete, 'ResearcherSignup_Onboarding_Start'),
  },
  {
    path: '/personal',
    name: routeNames.personal,
    component: Personal,
    beforeEnter: validateAndSendEvent(orgFormComplete),
  },
  {
    path: '*',
    beforeEnter: (to, from, next) => {
      return next({ name: routeNames.home });
    },
  },
];
